import React from 'react';
import { styled } from '@linaria/react';
import { UnstyledOpenInCodeSandboxButton } from '@codesandbox/sandpack-react';

import ExternalIcon from '@/components/AnimatedIcons/ExternalIcon';
import VisuallyHidden from '@/components/VisuallyHidden';

import ActionButton from './ActionButton';

const CodeSandboxButton = ({
  accentColor,
}: {
  accentColor: string;
}) => {
  const [isHovering, setIsHovering] = React.useState(false);

  // Normally, I add a `title` to show a tooltip,
  // but the UnstyledOpenInCodeSandboxButton comes with that
  // built-in.
  return (
    <Wrapper
      as={UnstyledOpenInCodeSandboxButton}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <ExternalIcon
        size={16}
        accentColor={accentColor}
        isHovering={isHovering}
      />
      <VisuallyHidden>Open in CodeSandbox</VisuallyHidden>
    </Wrapper>
  );
};

const Wrapper = styled(ActionButton)`
  transform-origin: center center;
  transition: opacity 250ms;
`;

export default CodeSandboxButton;
